<h1 matDialogTitle>Undo TFG Account Payment</h1>

<mat-dialog-content>
  <ng-container *ngIf="transaction; else loading">
    <div>
      <table style="width: 100%;">
        <tr>
          <th colspan="2">TFG Transaction</th>
          <th colspan="2">POS Payment</th>
        </tr>
        <tr>
          <th class="th-label">Transaction</th>
          <td class="td-value" style="text-align: right; padding-right: 16px;">{{transaction.transactionType}}</td>

          <th class="th-label">Equipment</th>
          <td class="td-value" style="text-align: right;">{{transaction.equipmentDesc}}</td>
        </tr>
        <tr>
          <th class="th-label">Request</th>
          <td class="td-value" style="text-align: right; padding-right: 16px;">{{transaction.requestType}}</td>

          <th class="th-label">Container</th>
          <td class="td-value" style="text-align: right;">{{transaction.containerDesc}}</td>
        </tr>
        <tr>
          <th class="th-label">Amount</th>
          <td class="td-value" style="text-align: right; padding-right: 16px;">{{transaction.transactionAmount |
            number:'1.2-2'}}</td>

          <th class="th-label">Amount</th>
          <td class="td-value" style="text-align: right;">{{transaction.amountPaid | number:'1.2-2' : ''}}
          </td>
        </tr>
        <tr>
          <th class="th-label">Store</th>
          <td class="td-value" style="text-align: right; padding-right: 16px;">{{transaction.storeName}}</td>

          <th class="th-label">Type</th>
          <td class="td-value" style="text-align: right;">{{transaction.paymentType}}
          </td>
        </tr>
        <tr>
          <th class="th-label">Created</th>
          <td class="td-value" style="text-align: right; padding-right: 16px;">{{transaction.requestCreationDate | date:
            'MMM d, yyyy HH:mm'}}</td>

          <th class="th-label">Created</th>
          <td class="td-value" style="text-align: right;">{{transaction.paymentCreationDate | date: 'MMM d, yyyy HH:mm'}}
          </td>
        </tr>
      </table>
    </div>
    <div>
      <form class="dynamic-form" [formGroup]="form" style="width: 100%;margin-top: 32px" autocomplete="off">
        <div fxLayout="row wrap" fxLayoutAlign="start start" fxFlexFill fxLayoutGap="16px grid">

          <mat-form-field fxFlex="100" width="100%">
            <mat-label>Approved By Manager Email</mat-label>
            <input matInput type="email" formControlName="approvedByEmail" autocomplete="new-password">
          </mat-form-field>

          <mat-form-field fxFlex="100" width="100%">
            <mat-label>Approved By Manager Password</mat-label>
            <input matInput type="password" formControlName="approvedByPwd" autocomplete="new-password">
          </mat-form-field>
        </div>
      </form>
    </div>
  </ng-container>
  <ng-template #loading>
    <mat-progress-bar mode="indeterminate"></mat-progress-bar>
  </ng-template>
</mat-dialog-content>

<mat-dialog-actions>
  <button mat-button matDialogClose>Cancel</button>
  <button [disabled]="!form.valid" mat-button (click)="save()">Undo Payment</button>
</mat-dialog-actions>
